import React, { useState, Fragment, useRef } from "react";
import { createContext } from "react";
import { Toast } from "primereact/toast";
import "../assets/css/toast.css";

const AlertContext = createContext();
const { Provider, Consumer } = AlertContext;

function AlertProvider({ children }) {
  const [summary, setSummary] = useState(null);
  const [detail, setDetail] = useState(null);
  const [severity, setSeverity] = useState(null);
  const toast = useRef(null);

  const normalizarDetalle = (detail) => {
    if (typeof detail === "string" || typeof detail === "number") {
      return String(detail);
    }

    if (detail?.mensaje) return detail.mensaje;
    if (detail?.message) return detail.message;
    if (detail === null || detail === undefined) return "";

    try {
      return JSON.stringify(detail);
    } catch (error) {
      return "Ocurrió un error inesperado.";
    }
  };
  const mensajeAlerta = (summary, detail, severity) => {
    toast.current?.show({
      severity,
      summary,
      detail: normalizarDetalle(detail),
      life: 3000,
    });
  };

  const mensajeAlerta2 = (summary, detail, severity) => {
    toast.current?.show({
      severity,
      summary,
      detail: normalizarDetalle(detail),
      sticky: true,
    });
  };

  const cerrarAlerta = () => {
    toast.current?.clear();
  };

  return (
    <Fragment>
      <Toast ref={toast} />
      <Provider
        value={{
          mensajeAlerta,
          mensajeAlerta2,
          cerrarAlerta,
        }}
      >
        {children}
      </Provider>
    </Fragment>
  );
}

export { AlertProvider, Consumer as AlertConsumer, AlertContext };
